<table mat-table [dataSource]="dataSource()" matSort [matSortDisableClear]="false" matSortActive="date" matSortDirection="desc">
  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef>
    </th>
    <td mat-cell *matCellDef="let row">
      <mat-checkbox (click)="$event.stopPropagation(); triggerAnalytics('AdManagement_SingleSelect_checkbox', 'AdManagement');"
                    (change)="$event ? selection.toggle(row) : null"
                    [checked]="selection.isSelected(row)">
      </mat-checkbox> &nbsp;
      <button mat-icon-button matTooltip="Edit" (click)='openEditAdsDialog(row); triggerAnalytics("AdManagement_EditAd_icon", "AdManagement");'><mat-icon color="accent">edit</mat-icon></button>
      <button mat-icon-button matTooltip="Schedule Dynamic Ad" (click)='openScheduleAdsDialog(row); triggerAnalytics("AdManagement_ScheduleAd_icon", "AdManagement");'><mat-icon color="accent">schedule</mat-icon></button>
    </td>
  </ng-container>

  <ng-container matColumnDef="actionsAffiliate">
    <th mat-header-cell *matHeaderCellDef class="mat-column-actions">
    </th>
    <td mat-cell *matCellDef="let row">
      <button class="material-default-size blue" mat-raised-button (click)="onGetLinkClick(row); triggerAnalytics('AdManagement_GetLink_button', 'AdManagement');"><img  width="17" height="16" [ngSrc]="'/assets/images/logo-symbol-on-dark.svg' | absUrl"> Get Link</button>&nbsp;
    </td>
  </ng-container>

  <ng-container matColumnDef="ad">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Ad</th>
    <td mat-cell *matCellDef="let row">
      <div class="td-liner" style="cursor: pointer" (click)="openAdPreview(row)">
          <ng-container *ngIf="row.ad_type === 'banner'">
            <img [ngSrc]="row.image_url" width="{{row.image_width}}" height="{{row.image_height}}">
            <div class="wash-out">Banner {{row.image_width}}x{{row.image_height}}</div>
          </ng-container>
          <ng-container *ngIf="row.ad_type === 'text'">
            <div class="link-text">{{row.link_text}}</div>
            <div class="wash-out">Text Ad</div>
          </ng-container>
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="adDetails">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Ad Details</th>
    <td mat-cell *matCellDef="let row">
      <div class="td-liner">
        <ng-container *ngIf="currentGroupMerchant$ | async">
          <div class="ad-title"><span matTooltip="Ad Name">{{row.ad_title}}</span></div>
          <div class="destination-url"><a [href]="row.destination_url" target="_blank" rel="noopener" matTooltip="Destination URL">{{row.destination_url | stripUrl}}</a></div>
        </ng-container>
        <ng-container *ngIf="(currentGroupMerchant$ | async) === false">
          <div class="merchant-name">{{row.merchant?.merchant_name}}</div>
          <div class="ad-title-affiliate"><span matTooltip="Ad Name">{{row.ad_title}}</span></div>
        </ng-container>
        <div class="wash-out"><span matTooltip="Ad ID">{{row.classic_merchant_ad_id}}</span></div>
        <div><span class="chip-like dynamic-label" *ngFor="let label of row.dynamic_labels" [attr.app-dynamic-label]="label" [matTooltip]="label==='New'?'Modified within seven days':label==='Dynamic'?'Scheduled to update':label==='Designated'?'Available for select affiliates':null">{{label}}</span></div>
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="performance">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Stats</th>
    <td mat-cell *matCellDef="let row">
      <div class="td-liner">
        <ng-container *ngIf="currentGroupMerchant$ | async">
          <table>
            <tr matTooltip="Active Affiliates"><td>AA:</td><td><a (click)="openActiveAffiliates(row)">{{row.calculated_active_websites ?? 0}}</a></td></tr>
            <tr matTooltip="Conversion Rate">
              <td>CR:</td>
              <td><a (click)="openConversionRate(row)">{{row.calculated_conversion_rate == null ? 'n/a' : row.calculated_conversion_rate === 0 ? '0%' : row.calculated_conversion_rate / 100 | percent:'1.2-2'}}</a></td>
            </tr>
          </table>
        </ng-container>
        <ng-container *ngIf="(currentGroupMerchant$ | async) === false">
          <table>
            <tr matTooltip="Conversion Rate">
              <td>CR:</td>
              <td><a (click)="openConversionRate(row)">{{row.calculated_conversion_rate == null ? 'n/a' : row.calculated_conversion_rate === 0 ? '0%' : row.calculated_conversion_rate / 100 | percent:'1.2-2'}}</a></td>
            </tr>
          </table>
        </ng-container>
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="date">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
    <td mat-cell *matCellDef="let row">
      <div class="td-liner">
          <table>
            <tr><td>Modified:</td><td>{{row.sort_updated_at | date:'mediumDate' }}</td></tr>
            <tr><td>Start:</td><td>{{row.start_date | date:'mediumDate' }}</td></tr>
            <tr><td>End:</td><td>{{row.end_date && (row.end_date | date:'mediumDate') || 'n/a'}}</td></tr>
            <tr *ngIf="row.schedule_start_date"><td>Updates:</td><td>{{ row.schedule_start_date | date:'mediumDate' }}</td></tr>
          </table>
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="visibleColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: visibleColumns;"></tr>

  <tr class="mat-mdc-row" *matNoDataRow>
    <td class="mat-mdc-cell" [attr.colspan]="7" *ngIf="isLoadingResults">loading...</td>
    <td class="mat-mdc-cell" [attr.colspan]="7" *ngIf="!dataError && !isLoadingResults">No ads match {{(currentGroupMerchant$ | async) ? 'status' : 'merchant'}} and filters.</td>
    <td class="mat-mdc-cell" [attr.colspan]="7" *ngIf="dataError && !isLoadingResults">An error occurred getting ads</td>
  </tr>
</table>

<mat-paginator [length]="totalItems" [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="25"></mat-paginator>
